export const formContentSx = {
  maxWidth: '350px',
  minWidth: '335px',
  paddingTop: '20px',
};

export const formTitleSx = (theme) => ({
  color: theme.palette.secondary.main,
  textAlign: 'center',
});
